const servicesSwiper = new Swiper('.services-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 8,
    centeredSlides: true,
    autoplay: false,
    allowTouchMove: true, // Enable touch/swipe gestures
    speed: 800,
    navigation: {
        nextEl: '.services-slider .swiper-controls .next',
        prevEl: '.services-slider .swiper-controls .prev',
    },
});